import {
  createProgramDefinition as publicCreateProgramDefinition,
  updateProgramDefinition as publicUpdateProgramDefinition,
  deleteProgramDefinition as publicDeleteProgramDefinition,
  getProgramDefinition as publicGetProgramDefinition,
  getProgramDefinitionByExternalIdAndNamespace as publicGetProgramDefinitionByExternalIdAndNamespace,
  queryProgramDefinitions as publicQueryProgramDefinitions,
  typedQueryProgramDefinitions as publicTypedQueryProgramDefinitions,
} from './benefit-programs-v1-program-definition-program-definitions.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ProgramDefinitionQuery,
  ProgramDefinitionsQueryBuilder,
  typedQueryProgramDefinitions as universalTypedQueryProgramDefinitions,
} from './benefit-programs-v1-program-definition-program-definitions.universal.js';

function customQueryProgramDefinitions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryProgramDefinitions(httpClient)(),
    typedQueryFunction: (query: ProgramDefinitionQuery) =>
      publicTypedQueryProgramDefinitions(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ProgramDefinitionsQueryBuilder;
  function overloadedQuery(
    query: ProgramDefinitionQuery
  ): ReturnType<typeof universalTypedQueryProgramDefinitions>;
  function overloadedQuery(query?: ProgramDefinitionQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreateProgramDefinition> &
    typeof publicCreateProgramDefinition
> = /*#__PURE__*/ createRESTModule(publicCreateProgramDefinition);
export const updateProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdateProgramDefinition> &
    typeof publicUpdateProgramDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdateProgramDefinition);
export const deleteProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeleteProgramDefinition> &
    typeof publicDeleteProgramDefinition
> = /*#__PURE__*/ createRESTModule(publicDeleteProgramDefinition);
export const getProgramDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetProgramDefinition> &
    typeof publicGetProgramDefinition
> = /*#__PURE__*/ createRESTModule(publicGetProgramDefinition);
export const getProgramDefinitionByExternalIdAndNamespace: MaybeContext<
  BuildRESTFunction<typeof publicGetProgramDefinitionByExternalIdAndNamespace> &
    typeof publicGetProgramDefinitionByExternalIdAndNamespace
> = /*#__PURE__*/ createRESTModule(
  publicGetProgramDefinitionByExternalIdAndNamespace
);
export const queryProgramDefinitions: MaybeContext<
  BuildRESTFunction<typeof customQueryProgramDefinitions> &
    typeof customQueryProgramDefinitions
> = /*#__PURE__*/ createRESTModule(customQueryProgramDefinitions);

export {
  Cascade,
  SortOrder,
  WebhookIdentityType,
} from './benefit-programs-v1-program-definition-program-definitions.universal.js';
export {
  ProgramDefinition,
  ExtendedFields,
  ProgramDefinitionTranslated,
  ProgramDefinitionTranslationDeleted,
  CreateProgramDefinitionRequest,
  CreateProgramDefinitionResponse,
  UpdateProgramDefinitionRequest,
  UpdateProgramDefinitionResponse,
  DeleteProgramDefinitionRequest,
  DeleteProgramDefinitionResponse,
  GetProgramDefinitionRequest,
  GetProgramDefinitionResponse,
  GetProgramDefinitionByExternalIdAndNamespaceRequest,
  GetProgramDefinitionByExternalIdAndNamespaceResponse,
  QueryProgramDefinitionsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryProgramDefinitionsResponse,
  CursorPagingMetadata,
  Cursors,
  UpsertProgramDefinitionRequest,
  UpsertProgramDefinitionResponse,
  GetOrCreateProgramDefinitionRequest,
  GetOrCreateProgramDefinitionResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  UpdateProgramDefinition,
  DeleteProgramDefinitionOptions,
  GetProgramDefinitionByExternalIdAndNamespaceOptions,
  ProgramDefinitionsQueryResult,
  ProgramDefinitionsQueryBuilder,
  ProgramDefinitionQuerySpec,
} from './benefit-programs-v1-program-definition-program-definitions.universal.js';
export { utils } from './benefit-programs-v1-program-definition-program-definitions.universal.js';
export {
  CascadeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  ProgramDefinitionQuery,
} from './benefit-programs-v1-program-definition-program-definitions.universal.js';
